import FeatureCard from '@/app/(home)/components/feature-card';
import FullWidthSection from '@/components/full-width-section';
import ImageOptimizer from '@/components/image-optimizer';
import { mainFeatures } from '@/data/main/feature.data';
import { formatKoreanCurrency, getDororoAppUrl } from '@/lib/utils';
import { useLatestStatistic } from '@/services/query/statistics.query';
import Link from 'next/link';
const WhySection = () => {
  const { data: statisticEntity } = useLatestStatistic();
  const recommendPrice =
    statisticEntity?.data?.recommendPrice !== undefined &&
    statisticEntity?.data?.recommendPrice !== null
      ? formatKoreanCurrency(statisticEntity.data.recommendPrice)
      : formatKoreanCurrency(200000);
  return (
    <FullWidthSection className="desktop:mx-auto bg-gradient-to-b from-[#F3F4FA] to-white">
      <section className="desktop:web-w desktop:mx-auto">
        <section className="desktop:py-30 w-full pt-10 pb-20">
          <div className="desktop:mb-20 mb-10 flex-col items-center justify-center text-center">
            <div className="mb-4 flex justify-center">
              <div className="desktop:h-auto desktop:w-[150px] desktop:aspect-[114/57] relative aspect-[98/49] w-[114px]">
                <ImageOptimizer
                  src="/images/main/why_bubble.svg"
                  alt="Why"
                  fill
                />
                <span className="typo-20 text-main-orange desktop:typo-22 desktop:pt-5 absolute inset-0 pt-3.5 font-extrabold">
                  Why
                </span>
              </div>
            </div>
            <h2 className="typo-28 desktop:typo-50 text-level-2 desktop:mb-6 desktop:gap-4 mb-4 flex items-center justify-center gap-2 text-center font-black">
              운전면허학원{' '}
              <span className="typo-28 desktop:typo-36 font-semibold">VS</span>{' '}
              드라이빙존
            </h2>
            <div className="typo-20 desktop:typo-40 desktop:px-[86px] desktop:py-[20px] inline-block rounded-full bg-white px-9 py-3 font-semibold">
              <span className="text-level-2">
                왜{' '}
                <span className="text-main-orange font-extrabold">
                  드라이빙존 운전면허
                </span>{' '}
                일까요?
              </span>
            </div>
          </div>

          <div className="desktop:grid-cols-2 desktop:px-0 desktop:gap-x-9 desktop:gap-y-10 grid grid-cols-1 gap-7 px-6">
            {mainFeatures.map((f, i) => (
              <FeatureCard key={i} {...f} />
            ))}
          </div>

          <div
            className="desktop:pt-40 desktop:-mt-10 desktop:pb-10 -mt-20 px-6 pt-40 text-center"
            id="only-drivingzone"
          >
            <p className="typo-28 text-level-2 desktop:typo-50 desktop:mb-10 mb-7 font-black">
              <span className="text-main-orange">Only</span> 드라이빙존에서
            </p>
            <div className="desktop:flex desktop:justify-center desktop:items-center desktop:gap-1 typo-24 text-level-2 desktop:typo-40">
              <p className="desktop:mb-0 mb-3 font-semibold">
                나의 운전 데이터를 분석하여
              </p>
              <p className="font-extrabold">자주 실수하는 부분을 집중 코치!</p>
            </div>
          </div>
          {/** 모바일 */}
          <div className="desktop:hidden flex">
            <div className="w-full flex-col items-center justify-center">
              <div className="relative mx-auto aspect-[322/381] w-full max-w-[322px]">
                <ImageOptimizer src="/images/main/ai.png" alt="Why" fill />
              </div>

              <div className="text-level-2 typo-18 mt-6 text-center leading-normal font-semibold">
                <span>운전분석으로 자주 감점되는 구간 및 습관을</span>
                <br />
                <span>교정하세요! AI 분석 코멘트까지! </span>
                <br />
                <span className="font-bold">
                  도로로 앱에서 분석 및 코칭을 도와드려요!
                </span>
              </div>

              <Link
                href={getDororoAppUrl()}
                className="my-7 flex justify-center"
              >
                <span className="typo-20 bg-main-orange mr-2 flex h-12 w-full max-w-[266px] items-center justify-center rounded-full font-extrabold text-white">
                  {/* <span className="typo-20 bg-stroke-grayblue mr-2 flex h-12 w-full max-w-[266px] items-center justify-center rounded-full font-extrabold text-white"> */}
                  앱 다운로드하기
                </span>
              </Link>
            </div>
          </div>

          {/** 웹 */}
          <div className="desktop:block hidden">
            <div className="w-full flex-col items-center justify-center">
              <div className="relative mx-auto aspect-[3336/2442] h-auto w-[1100px]">
                <ImageOptimizer
                  src="/images/main/ai_web_new.png"
                  alt="Why"
                  fill
                  className="ml-5"
                />
              </div>
            </div>
            <div className="bg-sub-white -mt-55 flex h-[280px] w-full justify-between rounded-[20px] border border-[#1111110d] px-20 py-15 shadow-xl">
              <div className="text-level-2 typo-24 flex flex-col gap-6 font-extrabold">
                <div className="mb-6 ml-88 flex gap-9">
                  <ImageOptimizer
                    src="/images/main/app_store.webp"
                    alt="Why"
                    width={164}
                    height={40}
                  />
                  <ImageOptimizer
                    src="/images/main/google_store.webp"
                    alt="Why"
                    width={154}
                    height={40}
                  />
                </div>
                <div className="font-semibold">
                  운전 분석으로 자주 감점되는 구간 및 습관을 교정하세요! AI 분석
                  코멘트까지!
                </div>
                <div>도로로 앱에서 분석 및 코칭을 도와드려요!</div>
              </div>

              <div className="relative">
                <ImageOptimizer
                  // src="/images/main/qr_code.webp"
                  src="/images/main/dororo_app_qrcode.png"
                  alt="Why"
                  width={160}
                  height={160}
                />
                {/* <div className="typo-22 absolute top-1/2 left-1/2 mt-1 -translate-x-1/2 -translate-y-1/2 text-center leading-tight font-bold text-white">
                  OPEN
                  <br />
                  예정
                </div> */}
              </div>
            </div>
          </div>

          <div className="desktop:mt-30 desktop:mb-15 mt-15 mb-7 flex justify-center">
            <ImageOptimizer
              src={'/images/icons/icon_circle_bottom_arrow.svg'}
              alt={''}
              width={40}
              height={40}
              className="desktop:size-[70px] size-10"
            />
          </div>
          <div className="desktop:mb-20 mb-8 px-4 text-center">
            <p className="typo-24 text-level-2 desktop:typo-40 desktop:mb-5 mb-3 font-semibold">
              이 모든 과정을{' '}
              <span className="font-black">{recommendPrice}에!</span>
            </p>
            <p className="typo-24 text-main-orange desktop:typo-50 font-black">
              2주간 무제한<span className="text-level-2">으로</span>
            </p>
          </div>

          {/** 웹 */}
          <div className="desktop:flex hidden items-center justify-center">
            <div className="relative flex h-[330px] w-[528px] flex-col items-center justify-center gap-5 bg-[url('/images/main/web_why_price_bg2.webp')] bg-contain bg-center bg-no-repeat">
              <div className="typo-40 pt-5 font-extrabold text-white">
                드라이빙존 운전면허
              </div>
              <div className="text-main-yellow text-[60px] leading-none font-black">
                {recommendPrice}
              </div>
            </div>
            <div className="-ml-8 flex h-[270px] w-[438px] flex-col items-center justify-center gap-5 bg-[url('/images/main/web_why_price_bg1.webp')] bg-contain bg-center bg-no-repeat">
              <div className="text-font-grayblue typo-28 font-semibold">
                운전면허학원 평균수강료
              </div>
              <div className="text-font-grayblue typo-40 font-extrabold">
                800,000원
              </div>
            </div>
          </div>
          {/** 모바일 */}
          <div className="desktop:hidden">
            <div className="flex h-[144px] flex-col items-center justify-center gap-3 bg-[url('/images/main/why_price_bg1.png')] bg-contain bg-center bg-no-repeat">
              <div className="text-font-grayblue typo-20 font-semibold">
                운전면허학원 평균수강료
              </div>
              <div className="text-font-grayblue typo-32 font-extrabold">
                800,000원
              </div>
            </div>
            <div className="relative flex h-[212px] flex-col items-center justify-center gap-3 bg-[url('/images/main/why_price_bg2.png')] bg-contain bg-center bg-no-repeat">
              <div className="typo-32 pt-4 font-extrabold text-white">
                드라이빙존 운전면허
              </div>
              <div className="typo-48 text-main-yellow font-black">
                {recommendPrice}
              </div>
            </div>
          </div>

          <div className="desktop:mt-20 desktop:mb-10 mt-10 mb-6 flex justify-center">
            <span className="bg-main-yellow typo-20 desktop:typo-40 desktop:py-5 desktop:w-[650px] w-[327px] rounded-full py-3 text-center font-semibold">
              자동차운전전문학원의{' '}
              <span className="font-extrabold">약 1/4 가격!!</span>
            </span>
          </div>

          {/** 웹 */}
          <div className="text-level-3 typo-24 desktop:flex hidden flex-col px-4 text-center leading-normal font-semibold">
            <span>
              2주간 드라이빙존을{' '}
              <span className="font-extrabold">
                무제한 이용할 수 있는 이용권을 {recommendPrice}에 이용
              </span>
              할 수 있어요!
            </span>
            <span>
              일반운전면허학원 대비{' '}
              <span className="font-extrabold">
                1/4 가격이지만 알찬 커리큘럼으로 진행할 수 있어요.
              </span>
            </span>
          </div>
          {/** 모바일 */}
          <div className="text-level-2 typo-18 desktop:hidden flex flex-col px-4 text-center leading-normal font-semibold">
            <span>
              2주간 드라이빙존을{' '}
              <span className="font-bold">무제한 이용할 수 있는</span>
            </span>
            <span>
              <span className="font-bold">
                이용권을 {recommendPrice}에 이용
              </span>
              할 수 있어요!
            </span>
            <span>일반운전면허학원 대비 </span>
            <span className="font-bold">
              1/4 가격이지만 알찬 커리큘럼으로 진행할 수 있어요.
            </span>
          </div>
        </section>
      </section>
    </FullWidthSection>
  );
};

export default WhySection;
